import { render, staticRenderFns } from "./message.vue?vue&type=template&id=d0ca9ec2&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0ca9ec2')) {
      api.createRecord('d0ca9ec2', component.options)
    } else {
      api.reload('d0ca9ec2', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=d0ca9ec2&", function () {
      api.rerender('d0ca9ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/message/message.vue"
export default component.exports